import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getPersonalData } from '@ers/root/App.selectors';
import { MenuItems } from '@ers/data';
import Menus from '@ers/data/Menus';
import { useBuildMenuItem } from '@ers/hooks/';
import PropTypes from 'prop-types';
import Card from '../Card';
import { Typo, Faq } from '..';
import { UserAvatar } from '.';
import Types from '../Avatar/AvatarTypes';
import MenuItemBody from '../Navigation/MenuItemBody';


const createMenuItem = (dispatch, type, name, nameRender, close) => {
    const [url, onClick] = useBuildMenuItem(type);
    const handleClick = useCallback(() => {
        if (dispatch && onClick) {
            onClick(dispatch);
        }
        close();
    });
    const label = nameRender(name);
    return (
        <MenuItemBody
            key={name} className="user-box__menu-item" url={url}
            handleClick={handleClick}
        >
            {label}
        </MenuItemBody>

    );
};
const UserBoxHooked = ({ close }) => {
    const dispatch = useDispatch();
    const user = useSelector(getPersonalData);

    return (
        <UserBox user={user} close={close} dispatch={dispatch} />
    );
};

UserBoxHooked.propTypes = {
    close: PropTypes.func.isRequired,
};
export const UserBox = ({ user: { avatar, firstname, lastname, email }, close, dispatch, style }) => (
    <Card hovering className="user-box" style={style}>
        <div className="user-box__info with---bottom-3 with-padding--bottom-3">
            <UserAvatar avatar={avatar} size={Types.UserBox} />
            <div className="user-box__details with-margin--left-2">
                <Typo.Subheader>
                    {`${firstname} ${lastname}`}
                </Typo.Subheader>
                <Typo.Caption>
                    {email}
                </Typo.Caption>
            </div>
        </div>
        <ul className="user-box__menus">
            <Faq />
            {MenuItems.filter((item) => item.place === Menus.UserBox && Boolean(item.name)).map(({ type, name, nameRender }) => createMenuItem(dispatch, type, name, nameRender, close))}
        </ul>
    </Card>
);
UserBox.propTypes = {
    user: PropTypes.shape({
        avatar: PropTypes.string,
        firstname: PropTypes.string,
        lastname: PropTypes.string,
        email: PropTypes.string
    }).isRequired,
    close: PropTypes.func.isRequired,
    dispatch: PropTypes.func
};
UserBox.defaultProps = {
    dispatch: null
};

export default UserBoxHooked;
